<template>
  <div ref="container" style="padding-top:8px;">
    <vonap-toolbar-label label="Report Date">
      <input id="periodControl" style="width: 125px;" />
    </vonap-toolbar-label>
    <vonap-toolbar-label label="From">
      <select id="fromDateDropDownList" style="width: 105px"></select>
    </vonap-toolbar-label>
    <vonap-toolbar-label label="To">
      <select id="toDateDropDownList" style="width: 105px"></select>
    </vonap-toolbar-label>
    <span v-show="showClient">
      <vonap-toolbar-label label="Client">
        <select id="clientDropDownList" style="width: 170px"></select>
      </vonap-toolbar-label>
    </span>
    <span v-show="showClient">
      <vonap-toolbar-label label="Counterparty">
        <select id="counterpartyDropDownList" style="width: 170px"></select>
      </vonap-toolbar-label>
    </span>
    <span v-show="!showClient">
      <vonap-toolbar-label label="Sector">
        <select id="sectorDropDownList" style="width: 170px"></select>
      </vonap-toolbar-label>
    </span>
    <span v-show="!showClient">
      <vonap-toolbar-label label="Division">
        <select id="divisionDropDownList" style="width: 170px"></select>
      </vonap-toolbar-label>
    </span>
    <vonap-toolbar-label label="Currency">
      <select id="ccyPairDropDownList" style="width: 114px"></select>
    </vonap-toolbar-label>
    <label v-show="showQuarter">Quarter:<input type="checkbox" id="quarterViewCheckBox"/></label>
    <label>Historical:<input type="checkbox" id="historicalViewCheckBox"/></label>
    <label v-show="showSummaryView && !isMaster">
      Summary View:<input type="checkbox" id="summaryViewCheckBox" />
    </label>
    <span v-show="showSummaryView && isMaster">
      <select id="groupType" style="width: 132px"></select>
    </span>
    <slot v-bind:toolbar="toolbar">
      <kendo-button type="button" @click="onExport" icon="excel" title="Export to Excel" />
      <span v-show="showChartButton">
        <kendo-button type="button" @click="onOpenChart" title="Open Chart">
          <v-icon small>pie_chart</v-icon>
        </kendo-button>
      </span>
    </slot>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import VonapToolbarLabel from '@/components/VonapToolbarLabel'

const $ = kendo.jQuery

export default {
  components: {
    VonapToolbarLabel,
  },
  props: {
    showQuarter: {type: Boolean, default: false},
    showClient: {type: Boolean, default: false},
    showSummaryView: {type: Boolean, default: false},
    marketId: {type: Number, required: true},
  },
  data() {
    return {
      toolbar,
      showChartButton: false,
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    isMaster() {
      return this.clientId == 0
    },
  },
  methods: {
    onExport() {
      this.$emit('export', toolbar.getSelectedValues())
    },
    onOpenChart() {
      this.$emit('openChart', toolbar.getSelectedValues())
    },
  },
  async mounted() {
    await toolbar.createToolbar(this)
    this.$emit('change', toolbar.getSelectedValues())
  },
  beforeDestroy() {
    kendo.destroy(this.$refs.container)
  },
}

const toolbar = (() => {
  'use strict'
  let period,
    fromDateDropDownList,
    toDateDropDownList,
    clientDropDownList,
    counterpartyDropDownList,
    sectorDropDownList,
    divisionDropDownList,
    ccyPairDropDownList,
    groupTypeDropDownList
  let vm

  function createExposureToolbar() {
    return new Promise(function(toolbarResolve) {
      period = $('#periodControl')
        .kendoDatePicker({
          format: 'yyyy-MM-dd',
          value: kendo.parseDate(localStorage.getItem('reportDate')) || new Date(),
          change: async e => {
            localStorage.setItem('reportDate', kendo.toString(e.sender.value(), 'yyyy-MM-dd'))
            await fromDateDropDownList.dataSource.read()
            fromDateDropDownList.select(0)
            await toDateDropDownList.dataSource.read()
            toDateDropDownList.select(0)
            vm.$emit('change', getSelectedValues())
          },
        })
        .getKendoDatePicker()
      //connect change event quarter view checkbox
      $('#quarterViewCheckBox').change(function() {
        $('#quarterViewCheckBox').is(':checked')
        vm.$emit('change', getSelectedValues())
      })

      $('#historicalViewCheckBox').change(async () => {
        await fromDateDropDownList.dataSource.read()
        fromDateDropDownList.select(0)
        await toDateDropDownList.dataSource.read()
        vm.$emit('change', getSelectedValues())
      })

      $('#summaryViewCheckBox').change(e => {
        vm.showChartButton = e.target.checked
        vm.$emit('change', getSelectedValues())
      })

      groupTypeDropDownList = $('#groupType')
        .kendoDropDownList({
          dataTextField: 'text',
          dataValueField: 'value',
          dataSource: [{text: 'Client', value: '1'}, {text: 'Counterparty', value: '2'}],
          index: 0,
          change: () => {
            vm.$emit('change', getSelectedValues())
          },
        })
        .data('kendoDropDownList')

      //cascade dropdown lists
      clientDropDownList = $('#clientDropDownList')
        .kendoDropDownList({
          dataTextField: 'name',
          dataValueField: 'clientId',
          dataSource: {
            transport: {
              read: {
                url: '/api/report/ExposureToolbar/GetUserClients',
                cache: false,
              },
            },
          },
          index: 0,
          change: async () => {
            await counterpartyDropDownList.dataSource.read()
            counterpartyDropDownList.select(0)
            await sectorDropDownList.dataSource.read()
            sectorDropDownList.select(0)
            await divisionDropDownList.dataSource.read()
            divisionDropDownList.select(0)
            await ccyPairDropDownList.dataSource.read()
            ccyPairDropDownList.select(0)
            await fromDateDropDownList.dataSource.read()
            fromDateDropDownList.select(0)
            await toDateDropDownList.dataSource.read()
            toDateDropDownList.select(0)
            ccyPairDropDownList.select(0)
            vm.$emit('change', getSelectedValues())
          },
        })
        .data('kendoDropDownList')

      return new Promise(function(clientResolve) {
        clientDropDownList.bind('dataBound', function() {
          if (vm.isMaster) {
            $('#summaryViewCheckBox').prop('checked', true)
            vm.showChartButton = true
            groupTypeDropDownList.value(1)
          } else {
            groupTypeDropDownList.value(2)
          }

          let clientId = vm.isMaster ? -1 : vm.clientId
          this.value(clientId)
          clientResolve()
        })
      })
        .then(function() {
          counterpartyDropDownList = $('#counterpartyDropDownList')
            .kendoDropDownList({
              dataTextField: 'code',
              dataValueField: 'counterpartyId',
              dataSource: {
                transport: {
                  read: {
                    url: '/api/report/ExposureToolbar/getCounterparties',
                    cache: false,
                    data: function() {
                      return {
                        clientId: clientDropDownList.value(),
                      }
                    },
                  },
                },
              },
              index: 0,
              change: async () => {
                vm.$emit('change', getSelectedValues())
              },
            })
            .data('kendoDropDownList')

          sectorDropDownList = $('#sectorDropDownList')
            .kendoDropDownList({
              dataTextField: 'sector',
              dataValueField: 'sectorId',
              dataSource: {
                transport: {
                  read: {
                    url: '/api/report/ExposureToolbar/GetUserSectors',
                    cache: false,
                    data: function() {
                      return {
                        clientId: clientDropDownList.value(),
                      }
                    },
                  },
                },
              },
              index: 0,
              change: async () => {
                await divisionDropDownList.dataSource.read()
                divisionDropDownList.select(0)
                await ccyPairDropDownList.dataSource.read()
                ccyPairDropDownList.select(0)
                await fromDateDropDownList.dataSource.read()
                fromDateDropDownList.select(0)
                await toDateDropDownList.dataSource.read()
                toDateDropDownList.select(0)
                ccyPairDropDownList.select(0)
                vm.$emit('change', getSelectedValues())
              },
            })
            .data('kendoDropDownList')

          return new Promise(function(resolve) {
            sectorDropDownList.bind('dataBound', function() {
              resolve()
            })
          })
        })
        .then(function() {
          divisionDropDownList = $('#divisionDropDownList')
            .kendoDropDownList({
              dataTextField: 'divisionName',
              dataValueField: 'divisionId',
              dataSource: {
                transport: {
                  read: {
                    url: '/api/report/ExposureToolbar/GetUserDivisions',
                    cache: false,
                    data: function() {
                      return {
                        sectorId: sectorDropDownList.value(),
                        clientId: clientDropDownList.value(),
                      }
                    },
                  },
                },
              },
              index: 0,
              change: async () => {
                await ccyPairDropDownList.dataSource.read()
                ccyPairDropDownList.select(0)
                await fromDateDropDownList.dataSource.read()
                fromDateDropDownList.select(0)
                await toDateDropDownList.dataSource.read()
                toDateDropDownList.select(0)
                ccyPairDropDownList.select(0)
                vm.$emit('change', getSelectedValues())
              },
            })
            .data('kendoDropDownList')

          return new Promise(function(resolve) {
            divisionDropDownList.bind('dataBound', function() {
              resolve()
            })
          })
        })
        .then(function() {
          ccyPairDropDownList = $('#ccyPairDropDownList')
            .kendoDropDownList({
              dataTextField: 'pairCode',
              dataValueField: 'ccyPairId',
              dataSource: {
                schema: {
                  parse: function(data) {
                    let ccys =
                      vm.marketId == 1
                        ? [
                            {
                              ccyPairId: 0,
                              pairCode: 'All',
                              foreignCcy: 'N/A',
                            },
                            ...data,
                          ]
                        : data
                    return ccys
                  },
                },
                transport: {
                  read: {
                    url: '/api/report/ExposureToolbar/GetCcyPairs',
                    cache: false,
                    data: () => {
                      return {
                        divisionId: divisionDropDownList.value(),
                        clientId: clientDropDownList.value(),
                        marketId: vm.marketId,
                      }
                    },
                  },
                },
              },
              index: 0,
              change: async () => {
                await fromDateDropDownList.dataSource.read()
                fromDateDropDownList.select(0)
                await toDateDropDownList.dataSource.read()
                toDateDropDownList.select(0)
                vm.$emit('change', getSelectedValues())
              },
            })
            .data('kendoDropDownList')
          return new Promise(function(resolve) {
            ccyPairDropDownList.bind('dataBound', function() {
              resolve()
            })
          })
        })
        .then(function() {
          fromDateDropDownList = $('#fromDateDropDownList')
            .kendoDropDownList({
              dataTextField: 'periodCode',
              dataValueField: 'toDate',
              dataSource: {
                transport: {
                  read: {
                    type: 'get',
                    url: '/api/report/FuturePastDistributedHedge/GetFromPeriods',
                    cache: false,
                    data: function() {
                      return {
                        asOfDate: kendo.toString(period.value(), 'yyyy-MM-dd'),
                        sectorId: sectorDropDownList.value(),
                        divisionId: divisionDropDownList.value(),
                        ccyPairId: ccyPairDropDownList.value(),
                        historical: $('#historicalViewCheckBox').is(':checked'),
                        clientId: clientDropDownList.value(),
                      }
                    },
                  },
                },
              },
              index: 0,
              change: async () => {
                await toDateDropDownList.dataSource.read()
                toDateDropDownList.select(0)
                vm.$emit('change', getSelectedValues())
              },
            })
            .data('kendoDropDownList')

          return new Promise(function(resolve) {
            fromDateDropDownList.bind('dataBound', function() {
              resolve()
            })
          })
        })
        .then(function() {
          toDateDropDownList = $('#toDateDropDownList')
            .kendoDropDownList({
              dataTextField: 'periodCode',
              dataValueField: 'toDate',
              dataSource: {
                transport: {
                  read: {
                    url: '/api/report/FuturePastDistributedHedge/GetToPeriods',
                    cache: false,
                    data: function() {
                      return {
                        asOfDate: kendo.toString(period.value(), 'yyyy-MM-dd'),
                        sectorId: sectorDropDownList.value(),
                        divisionId: divisionDropDownList.value(),
                        ccyPairId: ccyPairDropDownList.value(),
                        fromDate: fromDateDropDownList.value(),
                        clientId: clientDropDownList.value(),
                      }
                    },
                  },
                },
              },
              index: 0,
              change: function() {
                vm.$emit('change', getSelectedValues())
              },
            })
            .data('kendoDropDownList')

          return new Promise(function(resolve) {
            toDateDropDownList.bind('dataBound', function() {
              resolve()
            })
          })
        })
        .then(function() {
          toolbarResolve()
        })
    })
  }

  function getSelectedValues() {
    return {
      clientId: clientDropDownList.value(),
      counterpartyId: counterpartyDropDownList.value(),
      asOfDate: kendo.toString(period.value(), 'yyyy-MM-dd'),
      fromDate: fromDateDropDownList.value(),
      toDate: toDateDropDownList.value(),
      sectorId: sectorDropDownList.value(),
      divisionId: divisionDropDownList.value(),
      ccyPairId: ccyPairDropDownList.value(),
      ccyPair: ccyPairDropDownList.text(),
      quarterView: $('#quarterViewCheckBox').is(':checked'),
      historicalView: $('#historicalViewCheckBox').is(':checked'),
      summaryView: $('#summaryViewCheckBox').is(':checked'),
      groupType: groupTypeDropDownList.value(),
      marketId: vm.marketId,
    }
  }

  return {
    createToolbar($vm) {
      vm = $vm
      return createExposureToolbar()
    },
    getSelectedValues: getSelectedValues,
  }
})()
</script>
